import { CandidatePriority } from '@pflegia/types/api/candidate/candidate-priority';
import { NursingArea } from '@pflegia/types/api/candidate/nursing-area';
import { JobTitleEnum, RequiredJobTitle } from '@pflegia/types/api/job-title';

import { isTherapistJobTitle } from './is-therapist-job-title';

export const isPraxiaJobTitle = (jobTitle: RequiredJobTitle) => {
  const { title, area, trackingPriority } = jobTitle;
  return (
    [JobTitleEnum.PracticeManager, JobTitleEnum.AdministrativeStaff].includes(title as JobTitleEnum) ||
    (area?.includes(NursingArea.MedicalStaff) && !isTherapistJobTitle(jobTitle)) ||
    trackingPriority === CandidatePriority.B3
  );
};
